<template>
<div class="chapter">
<div class="inner_page">
<p class="image1"><img alt="image" src="images/line.png"/></p>
<h2 class="h2a">PART TWO</h2>
<p class="image"><img alt="image" src="images/line.png"/></p>
<p class="h2b"><em>Breaking All<br/>the Rules</em></p>
<p class="indent"><a id="page_27"></a></p><a id="page_27">
</a><p class="indent"><a id="page_27"></a><a id="page_28"></a></p><a id="page_28">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008.vue?841940b0